@if (
  {
    statusColor: statusColor(),
    statusValue: statusValue(),
    invoiceType: invoiceType()
  };
  as STATE
) {
  <badge [variant]="STATE.statusColor">{{
    STATE.invoiceType === 'proforma_invoice'
      ? 'Proforma'
      : (STATE.statusValue | invoiceStatus)
  }}</badge>
}
